import http from "@/utils/http";
let hr = "/hrApi";
let host = "/oaApi/nvc/public";
// // let qrcode = "/qrcodeApi";
// let config = "http://qrcode.nvc-lighting.com.cn";

export default {
  // upload: "http://192.168.200.120:8085", //测试
  // imgUrl: "http://192.168.200.120:8085/file/view/", //测试
  upload: "https://qw.nvc-lighting.com.cn:8082", //正式
  imgUrl: "https://qw.nvc-lighting.com.cn:8082/file/view/", //正式
  hrApiPrefix: `http://qw.nvc-lighting.com.cn:8088/hrApi`, // 图片地址
  getUpload: (data) =>
    http.post(`https://qw.nvc-lighting.com.cn:8082/file/upload`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  queryMedalTaskDetail: (data) =>
    http.post(`${hr}/medalTaskDetail/queryMedalTaskDetail`, data), // 查询
  addOrUpdate: (data) => http.post(`${hr}/medalTaskDetail/addOrUpdate`, data), // 新增/编辑
  downPptx: (data) =>
    http.post(`${hr}/medalTaskDetail/downPptx`, data, { responseType: "blob" }), // 下载ppt
  downExcel: (data) =>
    http.post(`${hr}/medalTaskDetail/downExcel`, data, {
      responseType: "blob",
    }), // 下载excel
  downPdf: (data) =>
    http.post(`${hr}/medalTaskDetail/downPdf`, data, { responseType: "blob" }), // 下载pdf
  downGatherExcel: (data) =>
    http.post(`${hr}/medalTaskDetail/downGatherExcel`, data, {
      responseType: "blob",
    }), // 下载汇总
  uploadNew: (data) =>
    http.post(`${hr}/file/uploadNew`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }), // 导入附件
  findListByName: (data) =>
    http.post(`${hr}/wecomDepartment/findListByName`, data), // 通过部门名称模糊查询
  queryMedalTaskDetailById: (data) =>
    http.post(`${hr}/medalTaskDetail/queryMedalTaskDetailById`, data), // 查看填报详情
  directory: (data) => http.post(`${hr}/user/directory`, data), // 查询
  viewFileId: (data) => http.get(`${hr}/file/view/${data.id}`), // 查看附件
  queryByType: (data) =>
    http.post(`${hr}/dict/queryByType`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }), // 查看type

  // upload 上传链接
  uploadUrl: "https://qw.nvc-lighting.com.cn:8082",
  // 新闻公告
  queryNewPageList: (data) => http.post(`${hr}/new/queryNewPageList`, data),
  // 新增编辑新闻公告
  addOrUpdateNew: (data) => http.post(`${hr}/new/addOrUpdateNew`, data),
  // 新增编辑新闻公告
  deleteNews: (data) => http.post(`${hr}/new/delete/${data}`),

  // 公告详情
  newsDetail: (data) => http.post(`${hr}/new/findById/${data}`),
  //发布公告
  publishCancel: (data) =>
    http.post(`${hr}/new/publishCancel/${data.id}/${data.taskStatus}`),
  //发布公告
  medalTaskQueryById: (data) => http.post(`${hr}/medalTask/queryById`, data),

  // 点赞卡
  // 员工点赞卡信息
  quaGetInfo: (data) => http.post(`${host}/api/kcard/index/getInfo`, data),
  // 可赠送列表
  quaLst: (data) => http.post(`${host}/api/kcard/index/lst`, data),
  // 已收到列表
  quaRev: (data) => http.post(`${host}/api/kcard/index/rev`, data),
  // 已收到列表
  quaCC: (data) => http.post(`${host}/api/kcard/index/cc`, data),
  // 搜索人员
  quaGetEmployeeInfo: (data) =>
    http.post(`${host}/api/cic/index/getEmployeeInfo`, data),
  // 详情
  quaDetail: (data) => http.post(`${host}/api/kcard/index/detail`, data),
  // 赠送卡片
  quaSend: (data) => http.post(`${host}/api/kcard/index/send`, data),
  // 回复卡片
  quaReply: (data) => http.post(`${host}/api/kcard/index/reply`, data),
  // 点赞 比心
  likesApi: (data) => http.post(`${host}/api/kcard/index/likes`, data),
  // 评论
  commentApi: (data) => http.post(`${host}/api/kcard/index/comment`, data),

  // 徽章类别 新增 编辑
  addOrUpdateMedalType: (data) =>
    http.post(`${hr}/medalType/addOrUpdate`, data),

  // 徽章类别 查询
  queryDataMedalType: (data) =>
    http.post(`${hr}/medalType/queryByPageList`, data),
  // 徽章类别 删除
  deleteMedalType: (data) => http.post(`${hr}/medalType/deleteById`, data),
  
  // 点赞卡自定义明细-新增
  addMedalTypeDetail: (data) => http.post(`${hr}/medalTypeDetail/add`, data),
  // 点赞卡自定义明细-修改
  editMedalTypeDetail: (data) => http.post(`${hr}/medalTypeDetail/edit`, data),
  // 点赞卡自定义明细-查询
  queryMedalTypeDetail: (data) => http.post(`${hr}/medalTypeDetail/queryByPage`, data),
  // 徽章类别 新增 编辑
  addOrUpdateMedal: (data) => http.post(`${hr}/medal/addOrUpdate`, data),

  // 徽章类别 查询
  queryByPageList: (data) => http.post(`${hr}/medal/queryByPageList`, data),
  // 徽章类别 删除
  deleteMedal: (data) => http.post(`${hr}/medal/deleteById`, data),
  // 徽章类别 删除
  medalCardSendApi: (data) => http.post(`${hr}/medalCard/send`, data),
  // 可赠送列表
  medalCardLstApi: (data) => http.post(`${hr}/medalCard/lst`, data),
  // 已收到&赠送列表
  medalCardRevApi: (data) => http.post(`${hr}/medalCard/rev`, data),
  // 抄送列表
  medalCardCcApi: (data) => http.post(`${hr}/medalCard/cc`, data),
  // 徽章详情
  medalCardDetailApi: (data) => http.post(`${hr}/medalCard/detail`, data),
  // 徽章详情
  medalCardAllApi: (data) => http.post(`${hr}/medalType/all`, data),
  // 徽章回复
  medalCardReplyApi: (data) => http.post(`${hr}/medalCard/reply`, data),
  // 徽章评论
  medalCardCommentApi: (data) => http.post(`${hr}/medalCard/comment`, data),
  // 徽章点赞&比心
  medalCardLikesApi: (data) => http.post(`${hr}/medalCard/likes`, data),
  // 徽章小铃铛
  getUnReadRecordsApi: (data) =>
    http.post(`${hr}/medalCard/getUnReadRecords`, data),
  // 回去最新三个徽章
  getLastThreeMedalsApi: (data) =>
    http.post(`${hr}/medalCard/getLastThreeMedals`, data),
  // 徽章 我的 信息
  getInfoApi: (data) => http.post(`${hr}/medalCard/getInfo`, data),
  // 徽章 我的 点赞消息
  likeLogApi: (data) => http.post(`${hr}/medalCard/likeLog`, data),
  // oA上传
  oaUploadFileAPi: (data) =>
    http.post(`${hr}/file/oaUploadFile`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  // 我的排名
  myRankingApi: (data) => http.post(`${hr}/medalCardNew/myRanking`, data),
  // 奋斗历程
  fightProcessAPi: (data) => http.post(`${hr}/medalCardNew/fightProcess`, data),
  // 我的徽章
  myBadgeApi: (data) => http.post(`${hr}/medalCardNew/myBadge`, data),
  // 我收到的& 我送出的
  medalCardNewReceivedApi: (data) =>
    http.post(`${hr}/medalCardNew/received`, data),
  // 价值观
  queryClassificationApi: (data) => http.post(`${hr}/medal/queryList`, data),
  // 往期单项按钮
  queryButton: (data) =>
    http.post(`${hr}/medalProjectManagement/queryButton`, data),
  // 往期优秀项目列表
  queryProjectListApi: (data) =>
    http.post(`${hr}/medalProjectManagement/queryProjectList`, data),

  // 荣耀 详情
  medalProjectManagementApi: (data) =>
    http.post(`${hr}/medalProjectManagement/queryList`, data),
  // 往期标题
  queryTaskPageList: (data) =>
    http.post(`${hr}/medalTask/queryTaskPageList`, data),
  // 往期新增
  addMedalProject: (data) =>
    http.post(`${hr}/medalProjectManagement/addOrUpdate`, data),
  // 往期删除
  deleteMedalProject: (data) =>
    http.post(`${hr}/medalProjectManagement/delete`, data),
  // 往期推送
  pushMedalProject: (data) =>
    http.post(`${hr}/medalProjectManagement/push`, data),
  // 根据工号获取上级
  queryParentNameApi: (data) => http.post(`${hr}/user/queryManager`, data),
  // 获取部门 一级 二级
  departmentToLevel: (data) =>
    http.post(`${hr}/wecomDepartment/departmentToLevel3`, data),
  // 获取部门 一级 二级
  queryRankingList: (data) => http.post(`${hr}/medalCardNew/rankingList`, data),
  // 获取用户信息
  queryByUsername: (data) => http.post(`${hr}/user/queryByUsername`, data),
  // 徽章发送记录
  queryMedalList: (data) =>
    http.post(`${hr}/medalCardNew/queryMedalList`, data),

  // 徽章发送统计
  queryMedalStatistics: (data) =>
    http.post(`${hr}/medalCardNew/queryMedalStatistics`, data),
  //导出徽章发送记录
  excelReportMedal: (data) =>
    http.post(`${hr}/medalCardNew/excelReportMedal`, data, {
      responseType: "blob",
    }),
  // 周年徽章推送
  medalYearByPageList: (data) =>
    http.post(`${hr}/medalYear/queryByPageList`, data),
  // 周年徽章推送 下载模板
  downTemplate: () =>
    http.get(`${hr}/medalYear/downTemplate`, {
      responseType: "blob",
    }),
  // 导入
  excelImportMedalYear: (data) =>
    http.post(`${hr}/medalYear/excelImport`, data.file, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  // 权限列表
  queryMedalUserPermission: (data) =>
    http.post(`${hr}/medalUserPermission/queryByPageList`, data),
  // 新增权限列表
  addOrUpdateMedalUserPermission: (data) =>
    http.post(`${hr}/medalUserPermission/addOrUpdate`, data),
  // 删除权限列表
  deleteMedalUserPermission: (data) =>
    http.post(`${hr}/medalUserPermission/delete`, data),
  // 徽章提报管理
  queryMedalTaskList: (data) =>
    http.post(`${hr}/medalTask/queryMedalTaskList`, data),

  // 勋章提报管理导出
  excelBadgeReport: (data) =>
    http.post(`${hr}/medalTask/excelReport`, data, {
      responseType: "blob",
    }),

  // 周报月报推送
  pushQueryList: (data) => http.post(`${hr}/medalPointPush/queryList`, data),
  // 个人提报记录导出
  personalRecordApi: (data) =>
    http.post(`${hr}/medalTask/excelReport`, data, {
      responseType: "blob",
    }),
  // 公益新增
  addPubBenefit: (data) => http.post(`${hr}/pubBenefit/create`, data),
  // 公益列表
  queryPubBenefitApi: (data) => http.post(`${hr}/pubBenefit/list`, data),
  // 公益删除
  deletePubBenefitApi: (data) => http.post(`${hr}/pubBenefit/del`, data),
  // 公益审批配置列表
  queryPubBenefitTypeListApi: (data) =>
    http.post(`${hr}/pubBenefit/getTypeList`, data),
  // 公益审批配置修改
  editPubBenefitTypeApi: (data) => http.post(`${hr}/pubBenefit/editType`, data),
  // 公益排行
  pubBenefitRankApi: (data) => http.post(`${hr}/pubBenefit/pbRank`, data),
  // 公益活动详情
  pubBenefitDetailApi: (data) => http.post(`${hr}/pubBenefit/detail`, data),
  // 公益签到码
  getSignInCodesApi: (data) =>
    http.post(`${hr}/pubBenefit/getSignInCodes`, data),
  // 公益签到
  pubBenefitSignInApi: (data) => http.post(`${hr}/pubBenefit/signIn`, data),
  // 公益签退
  pubBenefitSignOutApi: (data) => http.post(`${hr}/pubBenefit/signOut`, data),
  // 公益是否签到签退
  pubBenefitMyEbpInfoApi: (data) =>
    http.post(`${hr}/pubBenefit/myEbpInfo`, data),
  // 公益报名和个人公益申请
  pubBenefitApplyApi: (data) => http.post(`${hr}/pubBenefit/apply`, data),
  // 活动报名参与记录
  pubBenefitAdminActivityListApi: (data) =>
    http.post(`${hr}/pubBenefit/adminActivityList`, data),
  // 个人提报记录
  pubBenefitAdminPersonListListApi: (data) =>
    http.post(`${hr}/pubBenefit/adminPersonList`, data),
  // 个人提报记录导出
  adminPersonListExport: (data) =>
    http.post(`${hr}/pubBenefit/adminPersonListExport`, data, {
      responseType: "blob",
    }),
  // 团体提报记录导出
  adminGroupListExport: (data) =>
    http.post(`${hr}/pubBenefit/adminGroupListExport`, data, {
      responseType: "blob",
    }),

  // 下载往期优秀项目模板
  medalProjectManagementDownTemplate: () =>
    http.get(`${hr}/medalProjectManagement/downTemplate`, {
      responseType: "blob",
    }),
  // 导入往期优秀项目
  medalProjectManagementImportExcel: (data) =>
    http.post(`${hr}/medalProjectManagement/importExcel`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  // 积分记录导出
  scoreRecordExport: () =>
    http.get(`${hr}/medalProjectManagement/downTemplate`, {
      responseType: "blob",
    }),

  // 积分统计列表
  scoreStatList: (data) =>
    http.post(`${hr}/medalProjectManagement/getxxx`, data),
  // 积分统计导出
  scoreStatExport: (data) =>
    http.post(`${hr}/medalProjectManagement/getxxx`, data),

  // 积分明细
  scoreRecordListApi: (data) =>
    http.post(`${hr}/hsUserPoints/details/queryByPage`, data),

  // 2、积分管理查询
  getPointMgn: (data) => http.post(`${hr}/hsUserPoints/queryByPage`, data),

  // 更新用户积分冻结状态（冻结/解冻）
  updateUserPointStatus: (data) =>
    http.post(`${hr}/hsUserPoints/editStates`, data),

  // 调整用户积分（可批量）
  adjustUserPoints: (data) =>
    http.post(`${hr}/hsUserPoints/batch/adjustUserPoints`, data),

  // 查询积分基础
  getPointBaseSet: (data) =>
    http.post(`${hr}/hsThirdPartyMall/queryByPage`, data),
  // 修改积分基础

  editPointBaseSet: (data) => http.post(`${hr}/hsThirdPartyMall/edit`, data),

  // 查询积分来源
  getPointSet: (data) => http.post(`${hr}/hsPointSourceType/queryByPage`, data),

  // 修改积分来源配置
  updatePointSet: (data) => http.post(`${hr}/hsPointSourceType/edit`, data),

  // 新增积分来源配置
  addPointSet: (data) => http.post(`${hr}/hsPointSourceType/add`, data),

  // 查询积分排行榜

  getPointRank: (data) => http.post(`${hr}/hsUserPoints/rankingList`, data),

  // 获取职级
  getPositionLevel: (data) => http.post(`${hr}/mdEmployee/getDicts`, data),

  // 积分来源统计报表：

  sourceStatistics: (data) =>
    http.post(`${hr}/hsUserPoints/sourceStatistics`, data),
  // 7、积分分值范围统计
  totalPointsDistribution: (data) =>
    http.post(`${hr}/hsUserPoints/totalPointsDistribution`, data),
  //点赞卡广场点赞列表
  giveLikeList: (data) => http.post(`${hr}/medalCardNew/queryMedalList/ForGiveLike`, data),
  // 点赞卡-点赞/取消点赞
  giveLike: (data) => http.post(`${hr}/medalCardNew/give/like`, data),
  // 祝福评论查询(员工获收祝福)
  queryBlessingComment: (data) => http.post(`${hr}/hsBlessingComment/queryConfigAndComment`, data),
  // 写祝福(员工写祝福)
  sendBlessingComment: (data) => http.post(`${hr}/hsBlessingComment/add`, data),
  
  // 祝福记录后台管理-分页查询
  queryBlessingCommentByPage: (data) => http.post(`${hr}/hsBlessingComment/queryByPage`, data),
  
  // 祝福记录后台管理-修改（删除/恢复）
  editBlessingComment: (data) => http.post(`${hr}/hsBlessingComment/edit`, data),

  // 手动更新定时任务

  updateTask: (data) => http.post(`${hr}/hsThirdPartyMall/refreshSyncTask`, data),


  getLightInfo: (data) => http.post(`${hr}/csKnowledge/selectList`, data),
  getUploadLight: (data) =>
    http.post(`https://qw.nvc-lighting.com.cn:8082/file/uploadNfs`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
    // 更新灯图片信息
    updateLightInfo: (data) => http.post(`${hr}/csKnowledge/updateData`, data),
};
